<div class="mainForm-overlay">
  <div class="modal-header flex flex-row justify-between items-center">
    <h1>Form</h1>

    <mat-dialog-actions>
      <button class="material-icons" mat-dialog-close
              particleAnalytics
              analyticsCategory="ed-cell-editor-container"
              analyticsAction="close-btn">close
      </button>
    </mat-dialog-actions>

  </div>

  <form [formGroup]="inputForm" (ngSubmit)="onSubmitForm()">
    <mat-dialog-content>
      <mat-form-field appearance="outline">
        <mat-label>Title*</mat-label>
        <input matInput formControlName="title" placeholder="Form Title"/>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>
          Country*
        </mat-label>
        <mat-select formControlName="country">
          <div class="country-dropdown-scrollbar">
            <mat-option *ngFor="let country of data.allCountries" [value]="country">
              {{country.name}}
            </mat-option>
          </div>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Entity Name</mat-label>
        <input matInput formControlName="entityName" placeholder="Entity Name"/>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Category</mat-label>
        <mat-select formControlName="category">
          <div>
            <mat-option *ngFor="let ctg of data.category" [value]="ctg">
              {{ctg}}
            </mat-option>
          </div>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Form No.</mat-label>
        <input matInput formControlName="formNo" placeholder="Form No"/>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>View Type*</mat-label>
        <mat-select formControlName="viewType">
          <div>
            <mat-option *ngFor="let ctg of data.viewType" [value]="ctg">
              {{ctg}}
            </mat-option>
          </div>
        </mat-select>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-footer flex flex-row justify-between items-center">
      <button mat-button class="mat-flat-button orbitax-footer-button" mat-dialog-close (click)="closeDialog()">Cancel
      </button>
      <button mat-flat-button class="orbitax-footer-action-button mat-button mat-flat-button" type="button"
              (click)="onSubmitForm()">Done
      </button>
    </mat-dialog-actions>
  </form>
</div>
